import * as React from "react";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";
import { useLocalization } from "@shared-ui/localization-context";
import { PriceProps } from "../typings";

export const PriceContent = (props: PriceProps) => {
  const { formatText } = useLocalization();

  return (
    <div>
      {!props.isSoldOut ? (
        <UitkPriceLockup
          align={UitkPriceLockupAlign.LEFT}
          lockupPrice={props.priceToShow}
          priceSubtextFirst={props.priceMessage}
          a11yPrice={`${props.priceToShow}`}
        />
      ) : (
        <div className="uitk-type-heading-500 hotelSoldOut">
          <b>{formatText("recentlyViewedHotels.soldOut")}</b>
        </div>
      )}
    </div>
  );
};
